import { render } from "./ShipTrackModalTerms.vue?vue&type=template&id=655bc254&scoped=true"
import script from "./ShipTrackModalTerms.vue?vue&type=script&lang=js"
export * from "./ShipTrackModalTerms.vue?vue&type=script&lang=js"

import "./ShipTrackModalTerms.vue?vue&type=style&index=0&id=655bc254&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-655bc254"]])

export default __exports__